import React, { useContext } from "react";
import { Button, Paper, Stack, Typography } from "@mui/material";
import { checkStateValues } from "../config";
import { ReviewContext, SnackbarContext } from "../../../../provider/MyContexts";
import { Upload } from "@mui/icons-material";
import { ClearButton } from "../../components/MyIconButton";

export default function FileUploadArea() {
  const { uploadReviewResults, reviewFiles, handleReviewState, removeReviewFile } =
    useContext(ReviewContext);

  const { handleSnackbarOpen } = useContext(SnackbarContext);

  return (
    <Stack padding={2} direction={"column"} spacing={2} flex={1}>
      {/* <Typography variant="h5">過去結果をインポートする</Typography> */}
      <Stack
        spacing={3}
        padding={3}
        direction={"column"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        {Object.keys(checkStateValues).map((key, index) => {
          return (
            <Stack
              // 上下に中央ぞろえ
              direction={"row"}
              alignItems={"center"}
              justifyContent={"center"}
              key={index}
              spacing={1}
              width={"100%"}
              maxWidth={560}
            >
              <Stack flex={1} direction={"column"}>
                <Typography variant="label_S">{checkStateValues[key]}</Typography>
                <Paper variant="outlined" sx={{ padding: 1, flex: 1, width: "100%" }}>
                  <Typography variant="label_M" color={!reviewFiles[key] ? "white" : ""}>
                    {reviewFiles[key] || "file"}
                  </Typography>
                </Paper>
              </Stack>

              <Stack
                direction={"row"}
                // alignItems={"center"}
                // justifyContent={"space-between"}
                spacing={1}
                sx={{
                  paddingTop: "18px",
                }}
              >
                <Button
                  variant="outlined"
                  component="label"
                  sx={{
                    width: "32px",
                    aspectRatio: "1 / 1",
                    minWidth: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "4px",
                  }}
                  size="small"
                >
                  <Upload />
                  {/* <Typography variant="body_S">upload</Typography> */}
                  <input
                    type="file"
                    hidden
                    onChange={(e) => {
                      const files = e.target.files;
                      if (files && files.length > 0) {
                        const file = files[0];
                        if (!file.name.toLowerCase().endsWith(".json")) {
                          handleSnackbarOpen("error", "JSONファイルを選択してください");
                          return;
                        }
                        uploadReviewResults(file, key);
                      }
                    }}
                  ></input>
                </Button>
                <ClearButton
                  onClick={() => removeReviewFile(key)}
                  disabled={!reviewFiles[key] || reviewFiles[key] === ""}
                />
              </Stack>
            </Stack>
          );
        })}
      </Stack>
      <Stack width={"100%"} direction={"column"} alignItems={"center"} justifyContent={"center"}>
        <Button
          sx={{
            width: 160,
          }}
          disabled={!reviewFiles.excel && !reviewFiles.llm}
          variant="contained"
          onClick={() => {
            if (reviewFiles.excel) {
              handleReviewState("excel");
            } else if (reviewFiles.llm) {
              handleReviewState("llm");
            }
          }}
        >
          <Typography variant="button">確認に進む</Typography>
        </Button>
      </Stack>
    </Stack>
  );
}
